<template>
  <section id="home-page-menu-org">
    <div class="container">
      <div class="row">

        <clearfix :biggest="true"></clearfix>

        <div class="col-sm-12 content og-bg-light">
          <div class="align-center">
            <span class="font-big">&ldquo;&nbsp;</span>{{ $t('message.text.home.intro') }}<span class="font-big">&nbsp;&rdquo;</span>
          </div>

        </div>

        <clearfix :biggest="true" :bootstrap="true"></clearfix>

        <div class="col-sm-2 align-center" role="main">
          &nbsp;
        </div>

        <div class="col-sm-8 align-center">
          <div class="row" role="main">
            <div class="col-sm-6 align-center animated xFadeInLeft bs-padding-cancel">
              <div class="home-button home-center-button button-offer" @click="$router.push('/cars')">
                <div class="home-button-wrapper">
                  <span class="button-label">{{ $t('message.title.site.our_cars') }}</span>
                </div>
                <span class="label-placeholder">&nbsp;</span>
              </div>
            </div>
            <div class="col-sm-6 align-center animated xFadeInRight bs-padding-cancel">
              <div class="home-button home-center-button button-service">
                <div class="home-button-wrapper">
                  <span class="button-label">{{ $t('message.title.site.services') }}</span>
                </div>
                <span class="label-placeholder">&nbsp;</span>
              </div>
            </div>
            <div class="col-sm-6 align-center animated xFadeInLeft animateDelayed bs-padding-cancel">
              <div class="home-button home-center-button button-oldtimers-garage">
                <div class="home-button-wrapper">
                  <span class="button-label">{{ $t('message.title.site.garage') }}</span>
                </div>
                <span class="label-placeholder">&nbsp;</span>
              </div>
            </div>
            <div class="col-sm-6 align-center animated xFadeInRight animateDelayed bs-padding-cancel">
              <div class="home-button home-center-button button-clubs">
                <div class="home-button-wrapper">
                  <span class="button-label">{{ $t('message.title.site.club') }}</span>
                </div>
                <span class="label-placeholder">&nbsp;</span>
              </div>
            </div>
          </div>
        </div>

        <clearfix :biggest="true" :bootstrap="true"></clearfix>

      </div>
    </div>
  </section>
</template>

<script>
import Clearfix from '@/components/utils/Clearfix'

export default {
  components: {
    Clearfix
  }
}
</script>

<style>
#home-page-menu-org {
  background: url('../../assets/img/bg/arrows.png') 50% 0 fixed;
  height: auto;
  margin: 0 auto;
  width: 100%;
  position: relative;
  padding: 30px 0;
}
</style>



// WEBPACK FOOTER //
// MenuOrganization.vue?5962e971